module.exports = __webpack_public_path__ + "img/marcosVinicius.76240aed.webp";